.stickyComposer {
  position: sticky;
  bottom: 0;
  z-index: 10;
  background-color: var(--ant-color-bg-container);
}
